import { Stack } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import SettingContainer from '../../../SettingContainer';
import { RelatedProductsSectionGeneralSettingsProps } from '../../types/GeneralSettings.types';
import RelatedProductsSectionAutocomplete from './components/RelatedProductsSectionAutocomplete';
import RelatedProductsSectionSwitch from './components/RelatedProductsSectionSwitch';

const RelatedProductsSection = ({
  generalSettings,
  handleChangeAndBlur,
}: RelatedProductsSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_RELATED_PRODUCTS)}
      description={LangEnum.RELATED_PRODUCTS_GENERAL_SETTINGS_SECTION_DESCRIPTION}
    >
      <Stack spacing={2}>
        <RelatedProductsSectionAutocomplete
          handleChangeAndBlur={handleChangeAndBlur}
          generalSettings={generalSettings}
        />
        <RelatedProductsSectionSwitch
          handleChangeAndBlur={handleChangeAndBlur}
          generalSettings={generalSettings}
        />
      </Stack>
    </SettingContainer>
  );
};

export default RelatedProductsSection;
